import { any } from 'underscore'
import { Notifier } from '@airbrake/browser'

let airbrake

const ignoredMessages = [
  'Loading chunk 692 failed',
  'l.LegacyGlobal.should_do_lastpass_here is not a function',
  'Extension context invalidated',
  'mce-visual-caret-hidden',
  'Desmos',
  'MathJax.typesetPromise still undefined',
  'SIGHUP',
  'Sidekiq::Shutdown',
  'ChunkLoadError: Unhandled Promise Rejection',
  'Unhandled Promise Rejection: Loading chunk',
  'Cannot redefine property: googletag',
  'js-agent.newrelic.com',
  /Cannot use 'in' operator to search for '\d+' in undefined/,
]

const matchesMessage = (message, item) =>
  typeof item === 'string' ? message.indexOf(item) > -1 : item.test(message)

export const isIgnoredNotice = (notice) => {
  const { message, backtrace } = notice.errors[0]

  return (
    ignoredMessages.some((item) => matchesMessage(message, item)) ||
    any(backtrace, (line) => line.file.indexOf('safari-extension') > -1)
  )
}

export const getAirbrakeClient = () => {
  if (!airbrake && process.env.AIRBRAKE_PROJECT_ID) {
    airbrake = new Notifier({
      projectId: process.env.AIRBRAKE_PROJECT_ID,
      projectKey: process.env.AIRBRAKE_API_KEY,
      environment: process.env.RAILS_ENV,
    })

    airbrake.addFilter((notice) => (isIgnoredNotice(notice) ? null : notice))
  }

  return airbrake
}
